// Keep in sync with server/constants/recruitmentPermissionAliases.js
const recruitmentPermissionAliases: Record<string, string[]> = {
  'Recruitment:Candidates:view': ['HR:Candidates:view'],
  'Recruitment:Candidates:create': ['HR:Candidates:create'],
  'Recruitment:Candidates:edit': ['HR:Candidates:edit', 'HR:CVs:edit', 'HR:CVs:upload'],
  'Recruitment:Candidates:assess_fit': ['HR:Candidates:edit', 'Recruitment:Candidates:edit'],
  'Recruitment:Candidates:run_ai_fit': ['HR:Candidates:edit', 'Recruitment:Candidates:edit'],
  'Recruitment:Jobs:view': ['HR:Jobs:view'],
  'Recruitment:Jobs:create': ['HR:Jobs:create'],
  'Recruitment:Jobs:edit': ['HR:Jobs:edit', 'HR:Jobs:publish'],
  'Recruitment:Pipeline:view': ['HR:Interviews:view', 'HR:Candidates:view'],
  'Recruitment:Pipeline:reject': ['HR:Candidates:status'],
  'Recruitment:Pipeline:offer': ['HR:Candidates:status'],
  'Recruitment:Pipeline:hire': ['HR:Candidates:assign', 'HR:Candidates:status'],
  'Recruitment:Pipeline:move_stage': ['HR:Candidates:status', 'HR:Interviews:create', 'HR:Interviews:edit'],
  'Recruitment:Settings:view': ['HR:Settings:view'],
  'Recruitment:Settings:manage_skills': ['HR:Settings:edit'],
  'Recruitment:Settings:manage_stages': ['HR:Settings:edit', 'HR:Templates:edit'],
  'Recruitment:Settings:manage_fit_labels': ['HR:Settings:edit', 'Recruitment:Settings:manage_skills'],
  'Recruitment:Reports:view': ['HR:Reports:view', 'HR:Dashboard:view'],
};

export function recruitmentPermissionKeys(module: string, section: string, action: string): string[] {
  const key = `${module}:${section}:${action}`;
  return [key, ...(recruitmentPermissionAliases[key] || [])];
}

export function hasListedPermission(
  userPermissions: string[],
  module: string,
  section: string,
  action: string
): boolean {
  return recruitmentPermissionKeys(module, section, action).some((key) => userPermissions.includes(key));
}
